import React from 'react';
import { useNavigate } from 'react-router-dom';
import CancelLeaveRequestPage from './CancelLeaveRequestPage';

const CancelLeaveRequestPageWrapper = () => {
  const navigate = useNavigate();
  return <CancelLeaveRequestPage navigate={navigate} />;
};

export default CancelLeaveRequestPageWrapper;
